import { StrictMode, useEffect, useState } from "react";
import Router from "./Navigation";
import { ParallaxProvider } from "react-scroll-parallax";
import AOS from "aos";
import 'aos/dist/aos.css';

const App = () => {

  useEffect(() => {
    AOS.init({
      duration: 800,
      easing: 'ease-in-out',
      once: true,
      offset: 50,
    });

    // Scroll to top on page refresh
    window.scrollTo(0, 0);
  }, []);

  // Handle page refresh/load scroll to top
  useEffect(() => {
    const handleBeforeUnload = () => {
      window.scrollTo(0, 0);
    };

    window.addEventListener('beforeunload', handleBeforeUnload);
    
    return () => {
      window.removeEventListener('beforeunload', handleBeforeUnload);
    };
  }, []);

  const CookieConsentPopup = () => {
  const [showPopup, setShowPopup] = useState(false);

  // Cookie utility functions (matching HTML version)
  const setCookie = (name, value, days) => {
    const expires = `max-age=${days * 24 * 60 * 60}`;
    document.cookie = `${name}=${value}; ${expires}; path=/; domain=.hubitat.al; SameSite=Lax`;
  };

  const getCookie = (name) => {
    const nameEQ = name + "=";
    const ca = document.cookie.split(";");
    for (let i = 0; i < ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) === " ") c = c.substring(1);
      if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length);
    }
    return null;
  };

  const handleConsent = (type) => {
    console.log("Consent status:", type);
    // Add your code here if you want to load scripts or handle consent later
  };

  useEffect(() => {
    // Check if user has already given consent using cookies (matching HTML version)
    if (!getCookie("cookieConsent")) {
      setShowPopup(true);
    } else {
      handleConsent(getCookie("cookieConsent"));
    }
  }, []);

  const acceptCookies = () => {
    setCookie("cookieConsent", "accepted", 365);
    setShowPopup(false);
    handleConsent("accepted");
    console.log("All cookies accepted");
  };

  const dismissPopup = () => {
    setCookie("cookieConsent", "dismissed", 365);
    setShowPopup(false);
    handleConsent("dismissed");
    console.log("Cookie popup dismissed");
  };

  if (!showPopup) return null;

  return (
    <>
      <style>
        {`
          #cookie-popup {
            position: fixed;
            bottom: 20px;
            z-index: 2147483647 !important; 
            right: 20px;
            width: 400px;
            max-width: calc(100vw - 40px);
            padding: 24px;
            background: white;
            backdrop-filter: blur(15px);
            box-shadow: 0 12px 32px rgba(0, 0, 0, 0.25);
            border-radius: 20px;
            color: #2d3748;
            animation: slideIn 0.6s ease-out;
            border: 1px solid rgba(255, 255, 255, 0.3);
            box-sizing: border-box;
          }

          .popup-header {
            display: flex;
            justify-content: space-between;
            align-items: flex-start;
            margin-bottom: 16px;
            gap: 10px;
          }

          #cookie-popup h4 {
            margin: 0;
            font-size: 20px;
            font-weight: 600;
            color: #1a202c;
            flex: 1;
            line-height: 1.3;
          }

          .close-x {
            background: none;
            border: none;
            font-size: 24px;
            color: #718096;
            cursor: pointer;
            padding: 0;
            width: 30px;
            height: 30px;
            display: flex;
            align-items: center;
            justify-content: center;
            border-radius: 50%;
            transition: all 0.3s ease;
            flex-shrink: 0;
          }

          .close-x:hover {
            background: rgba(0, 0, 0, 0.1);
            color: #2d3748;
          }

          #cookie-popup p {
            margin: 0 0 20px;
            font-size: 14px;
            line-height: 1.6;
            color: #4a5568;
          }

          #cookie-popup a {
            color: #eb3778;
            font-weight: 500;
            text-decoration: none;
            transition: color 0.3s ease;
            word-break: break-word;
          }

          #cookie-popup a:hover {
            color: #d63384;
            text-decoration: underline;
          }

          .button-group {
            display: flex;
            gap: 12px;
            flex-wrap: wrap;
          }

          .btn {
            padding: 12px 20px;
            border: none;
            border-radius: 8px;
            font-size: 14px;
            font-weight: 600;
            cursor: pointer;
            transition: all 0.3s ease;
            flex: 1;
            min-width: 120px;
            font-family: system-ui, -apple-system, sans-serif;
            text-align: center;
            box-sizing: border-box;
          }

          .btn-primary {
            background: linear-gradient(135deg, #eb3778, #d63384);
            color: white;
            box-shadow: 0 4px 15px rgba(235, 55, 120, 0.3);
          }

          .btn-primary:hover {
            background: linear-gradient(135deg, #d63384, #b02a6c);
            transform: translateY(-2px);
            box-shadow: 0 6px 20px rgba(235, 55, 120, 0.4);
          }

          @keyframes slideIn {
            from {
              transform: translateY(50px);
              opacity: 0;
            }
            to {
              transform: translateY(0);
              opacity: 1;
            }
          }

          /* Responsive styles (same as before) */
          @media (max-width: 768px) {
            #cookie-popup {
              width: calc(100% - 32px);
              right: 16px;
              left: 16px;
              bottom: 16px;
              padding: 20px;
              border-radius: 16px;
            }
            .button-group {
              flex-direction: column;
              gap: 10px;
            }
            .btn {
              min-width: auto;
              width: 100%;
              padding: 14px 20px;
              font-size: 16px;
            }
            #cookie-popup h4 {
              font-size: 18px;
            }
            #cookie-popup p {
              font-size: 15px;
              line-height: 1.5;
            }
          }

          @media (max-width: 480px) {
            #cookie-popup {
              width: calc(100% - 20px);
              right: 10px;
              left: 10px;
              bottom: 10px;
              padding: 18px;
              border-radius: 12px;
            }
            #cookie-popup h4 {
              font-size: 17px;
            }
            #cookie-popup p {
              font-size: 14px;
              margin-bottom: 18px;
            }
            .btn {
              padding: 12px 18px;
              font-size: 15px;
            }
            .close-x {
              width: 28px;
              height: 28px;
              font-size: 22px;
            }
          }

          @media (max-width: 360px) {
            #cookie-popup {
              width: calc(100% - 16px);
              right: 8px;
              left: 8px;
              bottom: 8px;
              padding: 16px;
            }
            .popup-header {
              margin-bottom: 14px;
            }
            #cookie-popup h4 {
              font-size: 16px;
            }
            #cookie-popup p {
              font-size: 13px;
              margin-bottom: 16px;
            }
            .btn {
              padding: 12px 16px;
              font-size: 14px;
            }
          }

          @media (max-height: 500px) and (orientation: landscape) {
            #cookie-popup {
              bottom: 10px;
              max-height: calc(100vh - 20px);
              overflow-y: auto;
            }
            #cookie-popup p {
              font-size: 13px;
              margin-bottom: 16px;
            }
            .btn {
              padding: 10px 16px;
              font-size: 14px;
            }
          }

          @media (hover: none) and (pointer: coarse) {
            .btn {
              min-height: 44px;
              display: flex;
              align-items: center;
              justify-content: center;
            }
            .close-x {
              min-width: 44px;
              min-height: 44px;
            }
          }
        `}
      </style>
      <div id="cookie-popup">
        <div className="popup-header">
          <h4>Cookie Consent</h4>
          <button
            className="close-x"
            onClick={dismissPopup}
            aria-label="Close cookie popup"
          >
            ×
          </button>
        </div>
        <p>
          By clicking "Accept All Cookies", you agree to storing cookies on your
          device to enhance site navigation, analyze site usage, and assist in
          our marketing efforts.{" "}
          <a
            href="https://hubitat.al/cookies-policy/"
            target="_blank"
            rel="noopener noreferrer"
          >
            Privacy Policy
          </a>
        </p>
        <div className="button-group">
          <button className="btn btn-primary" onClick={acceptCookies}>
            Accept All
          </button>
        </div>
      </div>
    </>
  );
};

  return (
    <StrictMode>
      <ParallaxProvider>
        <Router />
      </ParallaxProvider>
    </StrictMode>
  );
};

export default App;
